'use strict';

angular.module('msLegacyActivities').controller('ActivityDoneCtrl', ['$scope', '$state', 'feedbackSvc', function ($scope, $state, feedbackSvc) {
  var vm = this;
  vm.giveFeedback = function (feedback) {
    feedbackSvc.activityFeedback($scope.activity, feedback).then(function () {
      $state.go('activityNext', {
        activity: $scope.activity.url
      });
    });
  };
}]);